import { Controller } from "@hotwired/stimulus";

export default class AttendanceListController extends Controller {
  static targets = ['offcanvas', 'body'];

  connect() {
    console.log("Hello, Attendance List", this.element);
    this.initOffCanvas();
  }

  initOffCanvas() {
    this.offcanvas = new bootstrap.Offcanvas(this.offcanvasTarget);
  }

  showOffCanvas(event) {
    console.log(event);
    console.log(event.params);

    const template = this.findTemplate(event.params.templateId);

    this.bodyTarget.innerHTML = '';
    this.bodyTarget.appendChild(
      template.content.cloneNode(true)
    );

    this.offcanvas.show();
  }

  findTemplate(templateId) {
    return this.element.querySelector(`#${templateId}`);
  }
}
